import {useDispatch} from 'react-redux'

import createRoutedStore from './store'
import routerConfig from 'router/config'

import createSagaMiddleware from 'redux-saga'
import rootSaga from 'redux/rootSaga'

const {router} = routerConfig

const sagaMiddleware = createSagaMiddleware({})

const store = createRoutedStore(router, sagaMiddleware)

sagaMiddleware.run(rootSaga)

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch

export default store
